var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{active: _vm.active}},[_c('span',[_vm._v("Sinonimo")]),(_vm.synonyms)?_c('div',{staticClass:"synonyms"},[_c('span',{staticClass:"syn"},[_vm._v(_vm._s(_vm.synonyms))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }